import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { IoMdEye } from "react-icons/io";
import { RiPencilFill } from "react-icons/ri";
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import SubscriberTypeAddAndEditModal from './components/SubscriberTypeAddAndEditModal';
import { useOutletTypesData, useSubscriberTypesData } from './hooks/useSubscriber';
import { FaEdit, FaEye } from 'react-icons/fa';


const SubscriberTypeColumns = (handleEditSubscriberType: (row: any) => void, handleView: (row: any) => void) => [
    {
        name: "Type Name",
        selector: (row: { TypeName: string }) => row.TypeName || '-',
        sortable: true,
        width: '40%',
        wrap: true
    },
    {
        name: "Outlet Types",
        selector: (row: { OutletTypeNames: string | any }) => row?.OutletTypeNames?.join(',') || '-',
        sortable: true,
        width: '40%',
        wrap: true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center" style={{}}>
                <div className="d-flex align-items-center">
                    <button
                        onClick={() => handleEditSubscriberType(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                    >
                        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                    </button>
                </div>
                <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
                    <button
                        onClick={() => handleView(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px", backgroundColor: '#2e8dd3' }}
                    >
                        <FaEye style={{ fill: "#fff" }} />View
                    </button>
                </div>
            </div>
        ),
        width: "20%"
    },
]


const SubscriberType = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { data: outletTypeData } = useOutletTypesData({ enable: true });
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const [paginationStates, setPaginationStates] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
    });
    const [rowData, setRowData] = useState(null)
    const { data } = useSubscriberTypesData({
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
        }
    });

    //  alert(JSON.stringify(rowData))
    // console.log('data?.response?.data?.data',data?.response?.data?.data)

    const handleEditSubscriberType = (row: any) => {
        setRowData(row)
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
    }
    const handleView = (row: any) => {
        navigate('/subscriberFields', { state: { subscriberRowData: row } })
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(true);
    }

    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };


    return (
        <div
            className="p-4"
        >
            <PageHeader
                title="Subscriber"
                buttons={
                    [
                        {
                            label: "+ Add Subscriber Type",
                            onClick: toggleModal,
                            color: "#2e8dd3",
                        },
                    ]}
            />
            <BasicDataTable
                paginationTotalRows={data?.response?.recordsTotal || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => { handleSearch(val) }}
                Title="Subscriber Types"
                columns={SubscriberTypeColumns(handleEditSubscriberType, handleView)}
                data={data?.response?.data?.data || []}
            />
            <SubscriberTypeAddAndEditModal data={outletTypeData} rowData={rowData} setCheckAddEditStatus={setCheckAddEditStatus} checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Subscriber Type' : 'Edit Subscriber Type'} />
        </div>
    )
}

export default SubscriberType
